import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const reportSchedulersReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_EVENTS_BY_GROUP_REPORT_SUCCESS:
            return  {
                ...state,
                refDataEventsByGroup: action.payload
            }

        default:
            return state;
    }
};

export default reportSchedulersReducer;
